﻿import React, { useContext, useCallback, useState } from 'react';
import Context, { context_type } from '@Util/Context';
import { useTranslation } from 'react-i18next';
import {
    Icon_Spin
} from '@Elements/ImageElements/Icons';

const Export_Current_Project_Button: React.FC = React.memo(() => {
    const [t] = useTranslation();
    const { stop_time, current_project }: context_type = useContext(Context);
    const [is_processing, set_is_processing] = useState<boolean>(false);
    const [show_spinner, set_show_spinner] = useState<boolean>(false);

    if (!stop_time) {
        throw new Error("Stop current project button: stop_time function does not exist");
    }

    /*const handleStopTime = useCallback(() => {
        if (current_project?.id) {
            stop_time(current_project.id.toString());
        } else {
            console.error("Current project ID is missing.");
        }
    }, [stop_time, current_project?.id]);*/

    const handleStopTime = useCallback(async () => {
        if (!current_project?.id) {
            console.error("Current project ID is missing.");
            return;
        }

        let spinnerTimeout: NodeJS.Timeout | null = null;

        // Only show spinner if stop_time takes longer than 500ms
        spinnerTimeout = setTimeout(() => {
            set_show_spinner(true);
            set_is_processing(true);
        }, 500);

        try {
            await stop_time(current_project.id.toString());
        } finally {
            if (spinnerTimeout) clearTimeout(spinnerTimeout);

            set_show_spinner(false);
            set_is_processing(false);
        }
    }, [stop_time, current_project?.id]);

    return (
        <button
            type="button"
            className="Button Button_Red"
            onClick={handleStopTime}
            title={t('Hover.StopTimeOnProject', { project_name: current_project?.projectName || '' })}
            disabled={is_processing}
        >
            {show_spinner && <Icon_Spin />}
            {!show_spinner && t('Button.Stop')}
        </button>
    );
});

export default Export_Current_Project_Button;